import ReplyIcon from '@mui/icons-material/Reply';
import React, { useMemo } from 'react';

import FlatButton from 'components/FlatButton';

const ReplyButton = props => (
  <FlatButton
    {...props}
    icon={useMemo(
      () => <ReplyIcon />,
      [],
    )}
    label='Reply'
  />
);

ReplyButton.propTypes = FlatButton.propTypes;

export default ReplyButton;
